<div class="wizzard -type-{{type}}" [ngClass]="{'-top-offset': topPadding}">
    <div class="wizzard__inner">
        <div class="wizzard__content">
            <ng-content></ng-content>
            <shared-wizzard-errors class="wizzard__errors"></shared-wizzard-errors>
        </div>
    </div>
</div>